import { EconsultApi as EconsultApiI } from "./chat";

export const EconsultApi = new EconsultApiI(undefined, "https://chat.nibyouservice.net");